import { render } from "./BottomNavButton.vue?vue&type=template&id=06e2c224&scoped=true"
import script from "./BottomNavButton.vue?vue&type=script&lang=js"
export * from "./BottomNavButton.vue?vue&type=script&lang=js"

import "./BottomNavButton.vue?vue&type=style&index=0&id=06e2c224&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e2c224"]])

export default __exports__